import SEO from '../components/SEO/SEO'
import InfoCard from '../components/Card/InfoCard'
import Layout from '../layout/Layout'
// import classes from "../styles/section.module.css";
import { newsInfo } from '../resources/newsInfo'

const News = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div>
          <div className="relative">
            <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
            <div className="mx-auto">
              <div className="relative">
                <div className="absolute inset-0"></div>
                <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-32">
                  <h1 className="text-4xl tracking-tight text-blue-dark font-extralight sm:text-5xl lg:text-6xl">
                    In the <span className="text-globeGreen">news.</span>
                  </h1>
                  <p className="mt-6 text-lg text-grey max-w-3xl">
                    Stay up to date with the latest news and announcements from
                    Evry Health and our impact in the healthcare industry.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <main>
          <section>
            <div className="max-w-screen-xl px-4 py-16 mx-auto border-t-2 sm:px-6 lg:px-8 border-grey-light">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {newsInfo.map(info => (
                  <div key={info.articleLink} className="h-full">
                    <InfoCard
                      image={info.companyLogo}
                      altText={info.companyLogoAltText}
                      title={info.articleTitle}
                      description={info.articleSummary}
                      link={info.articleLink}
                      linkText={info.linkText}
                    />
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </>
  )
}

export default News
